const Card = ({ children }) => {
    return (<>
        <article className="container rounded-md bg-cardColor drop-shadow-xl p-3 m-3 max-h-fit">
            {children}
        </article>
    </>);
}

export default Card;